(function Sidebar($, Adzuki)
{
	"use strict";

	var Sidebar                = {};
	var $expandedHubMenus      = Cookies.get('hub_menus_visibility') || '[]';
	var expanded_hub_menus     = [];
	var $rightSidebarContentId = $('#sidebar-right-content');
	var rowSelectedClass       = 'row-selected';

	Sidebar.ajaxCallback = null;

	/**
	 * Often we will be using the right sidebar in conjunction with a pseudo table. A user will client a "row" and the right sidebar will expand with more detail. We want to highlight
	 * the "row" clicked and remove the highlight from the "row" after the sidebar is closed or switched to something else
	 */
	Sidebar.removeRowSelected = function removeRowSelected($parent)
	{
		if ($parent) {
			$parent.find("." + rowSelectedClass).removeClass(rowSelectedClass);
		} else {
			$("." + rowSelectedClass).removeClass(rowSelectedClass);
		}
	};

	/**
	 * When the sidebar is used in conjunction with a table, first remove the highlighted row and set to another row
	 */
	Sidebar.setRowSelected = function setRowSelected($row)
	{
		var $parent = $row.closest('ul');

		this.removeRowSelected($parent);
		$row.addClass(rowSelectedClass);
	};

	/**
	 * Shows or hides the right sidebar
	 * @param  string state "off" of "on"
	 *
	 */
	Sidebar.toggleRightSidebar = function toggleRightSidebar(state)
	{
		if (state === 'off') {
			$(".content").removeClass('content-shifted-left');
			$(".sidebar-right").removeClass('sidebar-right-show');
			this.removeRowSelected();
		} else {
			$(".content").addClass('content-shifted-left');
			$(".sidebar-right").addClass('sidebar-right-show');
			$(".sidebar").removeClass('sidebar-show');
		}
	};

	/**
	 * Show a loading animation before content can be placed
	 */
	Sidebar.addLoadingAnimationRight = function addLoadingAnimationRight()
	{
		$rightSidebarContentId.html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span>');
	};

	/**
	 * Add content to the right sidebar
	 * @param html   htmlContent  The content you want displayed
	 * @param string formName     The name of the form to be initialized within the htmlContent, if any
	 */
	Sidebar.addContentRight = function addContentRight(htmlContent, formName)
	{
		$rightSidebarContentId.html(htmlContent);

		if (formName) {
			Adzuki.Form.initAjaxForm(formName);
		}

		if (Sidebar.ajaxCallback) {
			Sidebar.ajaxCallback();
		}
	};

	/**
	 * Pull content via ajax and place in the right sidebar
	 * @param  string ajaxPath    path to the script which is pulling the data
	 * @param  string formName    The name of the form within the ajax content to be initialized, if any
	 */
	Sidebar.populateRightContentViaAjax = function populateRightContentViaAjax(ajaxPath, formName)
	{
		this.addLoadingAnimationRight();

		Adzuki.Ajax.get(ajaxPath)
		.then(function populate(content) {
			Adzuki.Sidebar.addContentRight(content, formName);
		}).then(function checkScroll(e) {
			if (
				$rightSidebarContentId.find('.scrollable').length !== 0
				&& $('#sidebar-right-content').height() > $('.sidebar-right-show').height()
			) {
				$('#sidebar-right-scroll-section').removeClass('hidden');
				handleRightSideBarScrollIcon();
			} else {
				$('#sidebar-right-scroll-section').addClass('hidden');
			}
		});
	};

	/**
	 * checks if the parent row of the clicked sidebar trigger is currently flagged on.  If so, hide the sidebar
	 * @param  jQuery Object$row Parent row of the element clicked
	 * @return boolean           true if currently appearing in the sidebar
	 */
	Sidebar.currentlySelected = function currentlySelected($row)
	{
		var output = false;

		// means this one was already clicked and the content for it is currently already appearing in the sidebar, so we should close the sidebar
		if ($row.hasClass(rowSelectedClass)) {
			this.toggleRightSidebar('off');
			output = true;
		}

		return output;
	};

	$(document).ready(function documentReady()
	{
		expanded_hub_menus = $.parseJSON($expandedHubMenus);

		$("button.sidebar-toggle").click(function sidebarToggle()
		{
			Adzuki.Sidebar.toggleRightSidebar('off');
			$(".sidebar").toggleClass('sidebar-show');
		});

		$(".content").on("click", ".expand-right-sidebar-ajax", function rightSidebarAjax(e)
		{
			var $row      = $(this).closest('.table-row'),
			    ajax_path = $(this).data('url'),
			    form_name = $(this).data('form-name') || null;

			e.preventDefault();

			if (Adzuki.Sidebar.currentlySelected($row)) {
				Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name);
				Adzuki.Sidebar.toggleRightSidebar('on');
			} else {
				Adzuki.Sidebar.removeRowSelected();
				Adzuki.Sidebar.setRowSelected($row);
				Adzuki.Sidebar.populateRightContentViaAjax(ajax_path, form_name);
				Adzuki.Sidebar.toggleRightSidebar('on');
			}
		});

		$(".content").on("click", ".expand-right-sidebar-element", function rightSidebarElement(e)
		{
			var $row       = $(this).closest('.table-row'),
			    element_id = $(this).data('element-id'),
			    content    = $('#' + element_id).html() || '',
			    form_name  = $(this).data('form-name') || null;

			e.preventDefault();

			if (!Adzuki.Sidebar.currentlySelected($row)) {
				Adzuki.Sidebar.removeRowSelected();
				Adzuki.Sidebar.setRowSelected($row);
				Adzuki.Sidebar.addContentRight(content, form_name);
				Adzuki.Sidebar.toggleRightSidebar('on');
			}

			if ($(this).data('scrollable')) {
				$rightSidebarContentId.addClass('scrollable');
			} else {
				$rightSidebarContentId.removeClass('scrollable');
			}
		});

		$(".sidebar-right .close-sidebar " + Adzuki.FaIcon.getIconSelectorName('close')).click(function offSidebarToggle(e)
		{
			Adzuki.Sidebar.toggleRightSidebar('off');
		});

		$(".sidebar-collapse-btn").on('click', function collapseSidebar()
		{
			var btn             = $(this),
			    container       = btn.parent(),
			    sidebar_content = container.siblings(".container-fluid"),
			    sidebar         = btn.closest(".sidebar"),
			    sidebar_btns    = sidebar.find("span");

			if (btn.find("span").hasClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'))) {
				sidebar_content.hide();
				sidebar.toggleClass("collapsed");

				if ($('.bottom-panel').length) {
					$('.bottom-panel').css('margin-left', '29px');
				}

				setSidebarCookie("hidden");
			} else {
				sidebar_content.show();
				sidebar.toggleClass("collapsed");

				if ($('.bottom-panel').length) {
					$('.bottom-panel').css('margin-left', '250px');
				}

				setSidebarCookie("opened");
			}

			sidebar_btns.each(function collapseBothButtons()
			{
				var span = $(this);

				if (span.hasClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'))) {
					span.closest("button").attr("title", "Expand Sidebar");
					span.removeClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'));
					span.addClass(Adzuki.FaIcon.getIconStyleName('angle_double_right'));
				} else {
					span.closest("button").attr("title", "Collapse Sidebar");
					span.removeClass(Adzuki.FaIcon.getIconStyleName('angle_double_right'));
					span.addClass(Adzuki.FaIcon.getIconStyleName('angle_double_left'));
				}
			});
		});

		$(".hub-toggle").on('click', function toggleHub()
		{
			var hub              = $(this),
			    hub_key          = hub.data("hub"),
			    hub_menu         = hub.closest(".hub"),
			    hub_menu_links   = hub_menu.find("li"),
			    hub_cookie_index = expanded_hub_menus.indexOf(hub_key);

			if (hub.hasClass("collapsed")) {
				hub.removeClass("collapsed");
				hub.addClass("expanded");

				// add expanded menu to cookie
				if (hub_cookie_index < 0) {
					expanded_hub_menus.push(hub_key);
				}
			} else {
				hub.removeClass("expanded");
				hub.addClass("collapsed");

				// remove collapsed menu from cookie
				if (hub_cookie_index > -1) {
					expanded_hub_menus.splice(hub_cookie_index, 1);
				}
			}

			// set the expanded hub cookie array after expanding/collapsing
			setHubMenusCookie(expanded_hub_menus);

			hub_menu_links.each(function toggleHubLinks()
			{
				var li           = $(this),
					link_hub_key = li.data('section_hub');

				if (link_hub_key === hub_key) {
					if (li.hasClass("hidden")) {
						li.removeClass("hidden");
					} else {
						li.addClass("hidden");
					}
				}
			});
		});

		checkSidebar();
		checkHubMenus();
	});

	function setSidebarCookie(str)
	{
		Cookies.set('sidebarVisibility', str);
	}

	// grep for sidebar-visibility for all the moving parts
	function checkSidebar()
	{
		var visibility = Cookies.get('sidebarVisibility') || null;

		if (visibility === "hidden") {
			$(".sidebar-collapse-btn").click();

			if ($('.bottom-panel').length) {
				$('.bottom-panel').css('margin-left', '29px');
			}
		}
	}

	function setHubMenusCookie(hubs)
	{
		var cookie_domain = '.cruiseplannersnet.com';

		if (Adzuki.dev) {
			// on dev, use dev domain
			cookie_domain = '.adzuki.com';
		}

		Cookies.set('hub_menus_visibility', hubs, {domain: cookie_domain});

		$expandedHubMenus = hubs;
	}

	// toggle the expanded hubs from cookie
	function checkHubMenus()
	{
		$.each(expanded_hub_menus, function expandedHub(index, hub_key) {
			$('.hub-toggle[data-hub="' + hub_key + '"]:not(.no-auto-expand)').trigger('click');
		});
	}

	/**
	 * Handles the scroll icon section
	 */
	function handleRightSideBarScrollIcon () {
		$(document).on('click', '.sidebar-right-scroll-icon', function handleScrollClick (e) {
			e.preventDefault();
			let sidebar_identifier = $('.sidebar-right-show');
			sidebar_identifier.animate({ scrollTop: sidebar_identifier.scrollTop() + 90});
		});
	}

	Adzuki.Sidebar = Sidebar;
}(jQuery, window.Adzuki || {}));
